import { makeObservable, computed, reaction } from 'mobx';
import { MomentModel } from '../../entities';
import { Store } from '../../store/store';
import { BindingProps, StoreNode } from '../../store';
import { PlayerState } from '../player/playerState';

type Props = BindingProps<{
  jobId: string,
  player: PlayerState
}>;

export class TrainerTranscriptsState
  extends StoreNode {

  constructor(store: Store, props?: Props) {
    super(store, props);
    makeObservable(this, {
      player: computed,
      jobId: computed,
      job: computed,
      showOverlay: computed,
      transcriptMoments: computed,
      activeTranscriptMoment: computed,
    });

    reaction(() => this.activeTranscriptMoment, () => {
      const moment = this.activeTranscriptMoment;
      if (moment)
        this.domScrollToMoment(moment);
    });
  }

  // #region Resolved props
  get player(): PlayerState {
    return this.resolvedProps.player;
  }
  get jobId(): string {
    return this.resolvedProps.jobId;
  }
  get job() {
    return this.store.maybeGetJob(this.jobId);
  }

  get showOverlay(): boolean {
    return this.player.isTranscriptProcessing;
  }
  // #endregion

  get transcriptMoments(): MomentModel[] {
    return this.job?.transcriptMoments || [];
  }

  get activeTranscriptMoment(): MomentModel | null {
    const time = this.player.currentTime;
    return this.transcriptMoments
      .find(m => time >= m.startTime && time <= m.endTime) || null;
  }

  isTranscriptMomentActive(moment: MomentModel): boolean {
    return this.activeTranscriptMoment?.id === moment.id;
  }

  handleTranscriptClick(evt: React.MouseEvent, moment: MomentModel) {
    return this.player.invoke('jumpToMoment', { moment });
  }


  domScrollToMoment = (moment: MomentModel) => {
    if (!moment)
      return;

    const domMoment = this.domGetTranscriptMoment(moment.id);
    if (!domMoment)
      return;

    domMoment.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }

  domGetTranscriptMoment(id: string) {
    // TODO: scope querySelector to the transcript container element to avoid false matches
    return document.querySelector(`[data-moment="true"][data-moment-id="${id}"]`);
  }
}